import React, { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { FaSms } from "react-icons/fa";
import {
  dangerMessage,
  successMessage,
  warningMessage,
} from "../../../Toast/Toast";

const SendSMSForm = ({ setIsToggleViewSMS, attendeeID, eventID, token }) => {
  const [inputs, setInputs] = useState({ message: "" });
  const [btnLoad, setBtnLoad] = useState(false);
  const queryClient = useQueryClient();
  const key = ["myAttendees", eventID];
  const keySMS = ["allSMS", eventID];

  const handleChange = (event) => {
    const { name, value } = event.target;
    setInputs((inputs) => ({ ...inputs, [name]: value }));
  };

  const handleSend = (e) => {
    e.preventDefault();
    setBtnLoad(true);
    
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);
    
    const raw = JSON.stringify({
      body: inputs?.message,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
    
    fetch(
      `${process.env.REACT_APP_API}communication/sms?aid=${attendeeID}&eid=${eventID}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((res) => {
        setIsToggleViewSMS(false);
        setBtnLoad(false);
        if (res?.status === "success") {
          queryClient.invalidateQueries(key);
          queryClient.invalidateQueries(keySMS);
          successMessage("SMS successfully sent");
        } else {
          warningMessage("No phone number found");
        }
      })
      .catch((error) => {
        setIsToggleViewSMS(false);
        setBtnLoad(false);
        dangerMessage("No phone number found");
        console.error(error);
      });
  };

  return (
    <div style={styles.formContainer}>
      {/* Header Section */}
      <div style={styles.header}>
        <div style={styles.iconWrapper}>
          <FaSms style={styles.icon} />
        </div>
        <div>
          <h4 style={styles.title}>Send SMS</h4>
          <p style={styles.subtitle}>Send a text message to this attendee</p>
        </div>
      </div>

      {/* Form */}
      <form onSubmit={handleSend}>
        <div style={styles.formGroup}>
          <label style={styles.label}>
            Message<span className="text-danger">*</span>
          </label>
          <textarea
            name="message"
            value={inputs.message}
            onChange={handleChange}
            style={styles.textarea}
            placeholder="Type your SMS message here..."
            rows={6}
            required
          />
        </div>

        {/* Buttons */}
        <div style={styles.buttonContainer}>
          <button
            type="button"
            onClick={() => setIsToggleViewSMS(false)}
            style={styles.cancelButton}
            disabled={btnLoad}
          >
            Cancel
          </button>
          <button
            type="submit"
            style={{
              ...styles.submitButton,
              opacity: btnLoad ? 0.7 : 1,
              cursor: btnLoad ? "not-allowed" : "pointer",
            }}
            disabled={btnLoad}
          >
            {btnLoad ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" style={{ width: "14px", height: "14px" }} />
                Sending...
              </>
            ) : (
              <>
                <FaSms style={{ marginRight: "8px" }} />
                Send SMS
              </>
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

const styles = {
  formContainer: {
    padding: "8px",
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    marginBottom: "24px",
    padding: "16px",
    background: "linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)",
    borderRadius: "12px",
    border: "1px solid #fcd34d",
  },
  iconWrapper: {
    width: "56px",
    height: "56px",
    background: "linear-gradient(135deg, #f68a20 0%, #e57a10 100%)",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 4px 12px rgba(246, 138, 32, 0.3)",
  },
  icon: {
    color: "white",
    fontSize: "24px",
  },
  title: {
    margin: "0 0 4px 0",
    fontSize: "18px",
    fontWeight: "600",
    color: "#111827",
  },
  subtitle: {
    margin: 0,
    fontSize: "13px",
    color: "#6b7280",
  },
  formGroup: {
    marginBottom: "20px",
  },
  label: {
    display: "block",
    fontSize: "14px",
    fontWeight: "600",
    color: "#374151",
    marginBottom: "8px",
  },
  textarea: {
    width: "100%",
    padding: "12px 16px",
    border: "2px solid #e5e7eb",
    borderRadius: "10px",
    fontSize: "14px",
    resize: "vertical",
    fontFamily: "inherit",
    transition: "all 0.2s",
    boxSizing: "border-box",
  },
  buttonContainer: {
    display: "flex",
    gap: "12px",
    justifyContent: "flex-end",
    marginTop: "24px",
    paddingTop: "20px",
    borderTop: "2px solid #f3f4f6",
  },
  cancelButton: {
    padding: "10px 20px",
    border: "2px solid #e5e7eb",
    background: "white",
    color: "#374151",
    borderRadius: "10px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s",
  },
  submitButton: {
    padding: "10px 24px",
    border: "none",
    background: "linear-gradient(135deg, #f68a20 0%, #e57a10 100%)",
    color: "white",
    borderRadius: "10px",
    fontSize: "14px",
    fontWeight: "600",
    display: "flex",
    alignItems: "center",
    boxShadow: "0 4px 12px rgba(246, 138, 32, 0.3)",
    transition: "all 0.2s",
  },
};

export default SendSMSForm;